import CyberRangeCard from "./CyberRangeCard";

const CourseList = ({ mappedCourses, openLabInNewTab }) => {
    return (
        mappedCourses.length > 0 && (
            <div className="row g-4 mb-4 px-3">
                {mappedCourses.map((m, i) => (
                    <div
                        key={m.courseId}
                        className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 position-relative"
                        onClick={() => openLabInNewTab(m)}
                    >
                        <CyberRangeCard id={m.courseId} title={m.courseName} />
                    </div>
                ))}
            </div>
        )
    );
};

export default CourseList;